import Capa1 from "../assets/Capa_1.svg";
import Capa1_2 from "../assets/Capa_1 (2).svg";
import Capa1_3 from "../assets/Capa_1 (3).svg";
import Svg273 from "../assets/svg273.svg";
import Svg7425 from "../assets/svg7425.svg";

interface StatCardProps {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

const StatCard = ({ value, label, icon }: StatCardProps) => (
  <div className="flex-1 flex flex-col items-center gap-3 sm:gap-5 max-w-[200px]">
    {/* Icon */}
    <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 relative flex items-center justify-center">
      {icon}
    </div>

    {/* Value + Label */}
    <div className="flex flex-col items-center gap-2 text-center">
      <div className="text-blue-900 text-lg sm:text-xl lg:text-2xl font-bold font-['Nunito Sans']">
        {value}
      </div>
      {/* Fixed height for alignment */}
      <div className="h-[48px] sm:h-[56px] lg:h-[52px] max-w-[200px] flex items-center justify-center px-2 text-zinc-700 text-sm sm:text-base lg:text-xl font-normal leading-tight font-['Nunito Sans']">
        {label}
      </div>
    </div>
  </div>
);

export default function Stats() {
  return (
    <div className="w-full m-auto max-w-[1440px] p-4 sm:p-8 lg:p-16 bg-slate-50 flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-8 lg:gap-6 flex-wrap">
      <StatCard
        value="1 Billion +"
        label="Data Points Captured"
        icon={<img src={Capa1} alt="Data Points" className="w-full h-full object-contain" />}
      />
      <StatCard
        value="1,000,000+"
        label="Users Impacted"
        icon={<img src={Svg273} alt="Users Impacted" className="w-full h-full object-contain" />}
      />
      <StatCard
        value="9+"
        label="Countries with Deployed Processes"
        icon={<img src={Capa1_2} alt="Countries" className="w-full h-full object-contain" />}
      />
      <StatCard
        value="10+"
        label="Industries Served"
        icon={<img src={Svg7425} alt="Industries" className="w-full h-full object-contain" />}
      />
      <StatCard
        value="1,000+"
        label="Analytics Solutions Delivered"
        icon={<img src={Capa1_3} alt="Solutions" className="w-full h-full object-contain" />}
      />
    </div>
  );
}
